export { default as nudgeMutations } from './nudge'



// WEBPACK FOOTER //
// ./src/store/mutations/index.js